import type { InjectionKey } from 'vue'

import type { useJSBridge } from './useJSBridge'

export const JS_BRIDGE_INJECTION_KEY = Symbol('jsBridge') as InjectionKey<
  ReturnType<typeof useJSBridge>
>
